import React from 'react'
import { useTranslation } from 'react-i18next'

import TikTokCampaignBudgetSectionForm from '../../../../../ReusableFormSections/reusableBudgetSections/TikTokBudgetSections/TikTokCampaignBudgetSection/TikTokCampaignBudgetSectionForm'

import useStyles from '../../../../../../styles/common/drawerForms'

const BudgetSection = ({ editItemData: campaign, ...formProps }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { budget } = campaign

  return !budget ? (
    <div className={classes.sectionPreview}>
      <p>
        {t('Budgets for this campaign are set at an ad group level. Please edit your ad groups to manage the budget.')}
      </p>
    </div>
  ) : (
    <TikTokCampaignBudgetSectionForm campaign={campaign} {...formProps} />
  )
}

export default BudgetSection
